<template>
  <div class="request-subjects text-dark">
    <div class="request-subjects__header">
      <h1>Ønsker til fagfordelingen</h1>
    </div>
    <Loader v-if="isLoading || isLoadingSubjectsRequests"></Loader>
    <div class="request-subjects-grid" v-else>
      <RequestSubjectsUser
        :user="user"
        :userSubjects="userRequestedSubjectsWithProps"
        :allCalendarsInHash="allCalendarsInHash"
        :loadingSubjects="loadingSubjects"
        @removeSubject="onSetSubjectRequest($event)">
      </RequestSubjectsUser>
      <div class="doTable">
        <div class="subject-dist__header">
          <div class="subject-dist__header__left">
            <!--
            <Tabslist :tabs="['Fag', 'Opgaver']" :selected="selectedTab" @select="onSelectTab"></Tabslist>
            <div class="do-search" v-if="selectedTab === 'Fag'">
              <input type="search" class="do-input" placeholder="Søg på fag" @input="debounceSearch">
            </div>
            -->
            <DoFiltersFilter
              v-if="selectedTab === 'Fag'"
              :title="'Klasser'"
              :tags="klassTags"
              :selectedTags="selectedKlassFilters"
              @select="toggleKlassTag"
              @clear="selectedKlassFilters = []"
            >
            </DoFiltersFilter>
            <DoFiltersFilter
              v-if="selectedTab === 'Fag'"
              :title="'Status på fag'"
              :tags="statusFilters"
              :selectedTags="selectedStatusFilters"
              @select="toggleSelectedStatusFilters"
              @clear="selectedStatusFilters = []"
            >
            </DoFiltersFilter>
          </div>
        </div>
        <table class="do-table do-table__tasks" v-if="selectedTab === 'Opgaver'">
          <thead>
          <tr>
            <th>Opgave</th>
            <th class="td-number">Timer</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="task in tasks" :key="task.id">
            <td>
              <button class="do-bttn do-bttn--request-subject marg-1-right" @click="onSetSubjectRequest (task.id)">
                Ønsk
              </button>
              {{ task.name }}
            </td>
            <td class="td-number">{{ task.hours }}</td>
          </tr>
          </tbody>
        </table>
        <ul class="doTable__items" v-else>
          <li class="doTable__klass"
              v-for="(klassCal, idx) in filteredKlassCals"
              :key="klassCal.id">
            <div class="doTable__klass__header">
              <div>{{ klassCal.name }}</div>
            </div>
            <ul class="subjects">
              <li class="subjects_subject"
                  v-for="subject in klassCal.vSubjects"
                  :key="subject.id"
                  :class="[{'subject--has-user': subject.vRequestedBy.length > 0}]"
                  :style="{'background': subject.color}"
                  :content="!subject.vHasTeachers ? 'Ønsket af ' + subject.vRequestedBy : subject.vUserNames + ' er valgt'"
                  v-tippy="{
            arrow: true,
            onShow: () => subject.vRequestedBy.length > 0 || subject.vHasTeachers
          }">

                {{ subject.name }} ({{ subject.hours }})
                <button class="do-bttn do-bttn--request-subject"
                        v-if="!subject.vHasTeachers"
                        :class="{'do-bttn--remove': subject.vIsRequestedByUser}"
                        @click="onSetSubjectRequest(subject.id)">
                  <div class="do-spinner do-spinner__small" v-if="subject.vIsLoading"></div>
                  <template v-else>
                    {{ subject.vIsRequestedByUser ? 'Fjern ønske' : 'Ønsk' }}
                  </template>
                </button>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Loader from '../common/Loader.vue'
import DoFiltersFilter from '../DoFilters/DoFiltersFilter.vue'
import RequestSubjectsUser from './RequestSubjectsUser.vue'
import docendo from '../../docendo'
import Tabslist from '../common/Tabslist.vue'

export default {
  components: {Tabslist, RequestSubjectsUser, DoFiltersFilter, Loader},
  data () {
    return {
      selectedTab: 'Fag',
      selectedKlassFilters: [],
      statusFilters: [
        'Fag uden tildelt underviser',
        'Fag med tildelt underviser',
        'Fag jeg har ønsket'
      ],
      selectedStatusFilters: ['Fag uden tildelt underviser'],
      loadingSubjects: {},
      subjectSearchQuery: '',
      debounceTimer: null,
      schoolYearId: null
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    user () {
      return this.$store.state.user
    },
    userCalendarId () {
      return this.user && this.user.user_calendar_id ? this.user.user_calendar_id : null
    },
    isLoading () {
      return this.$store.state.subjects.isLoading
    },
    subjects () {
      return this.$store.state.subjects.subjects
    },
    requestedSubjects () {
      return this.$store.getters.subjectsRequestsInHash
    },
    isShowSubjectsWithoutTeachers () {
      return this.selectedStatusFilters.includes('Fag uden tildelt underviser')
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    subjectsInKlassHash () {
      return this.$store.getters.subjectsInKlassHash
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    },
    subjectsInUserHash () {
      return this.$store.getters.subjectsInUserHash
    },
    klassCalendars () {
      const cals = []
      const seenIds = new Set()
      this.subjects.forEach(subject => {
        subject.cals.forEach(cal => {
          if (cal.calendar_type === 'klass' && !seenIds.has(cal.id)) {
            seenIds.add(cal.id)
            cals.push(cal)
          }
        })
      })
      return cals.sort((a, b) => a.name.localeCompare(b.name))
    },
    klassTags () {
      return this.klassCalendars.map(klassCalendar => klassCalendar.name)
    },
    calsWithProps () {
      const klasses = this.klassCalendars

      return klasses.map(klass => ({
        ...klass,
        vSubjects: (this.subjectsInKlassHash[klass.id] || [])
          .filter(subjectId => {
            const subject = this.subjectsInHash[subjectId] || {}
            return subject.subject_type !== 'frame'
          })
          .map(subjectId => {
            const subject = this.subjectsInHash[subjectId] || {}

            return {
              ...subject,
              vRequestedBy: this.getSubjectedRequestedBy(subjectId),
              vHasTeachers: this.subjectHasTeachers(subjectId),
              vUserNames: this.getUserNames(subjectId),
              vIsRequestedByUser: this.getIsSubjectRequestedByUser(subjectId),
              vIsLoading: this.getIsSubjectLoading(subjectId)
            }
          })
      }))
    },
    filteredKlassCals () {
      let klasses = this.calsWithProps

      // Filtrer klasser baseret på valgte klasses
      if (this.selectedKlassFilters.length > 0) {
        klasses = klasses.filter(klass => this.selectedKlassFilters.includes(klass.name))
      }

      // Hvis ingen statusfiltre er valgt, vis alle subjects
      const hasStatusFilters = this.selectedStatusFilters.length > 0

      return klasses.map(klass => ({
        ...klass,
        vSubjects: klass.vSubjects.filter(subject => {
          // Filtrering baseret på statusfiltre
          const matchesStatusFilter = !hasStatusFilters || (
            this.selectedStatusFilters.includes('Fag uden tildelt underviser') && !subject.vHasTeachers ||
            this.selectedStatusFilters.includes('Fag med tildelt underviser') && subject.vHasTeachers ||
            this.selectedStatusFilters.includes('Fag jeg har ønsket') && subject.vIsRequestedByUser
          )

          // Filtrering baseret på søgefeltet
          const matchesSearch = !this.subjectSearchQuery ||
            subject.name.toLowerCase().includes(this.subjectSearchQuery.toLowerCase())

          // Begge betingelser skal være opfyldt
          return matchesStatusFilter && matchesSearch
        })
      }))
    },
    subjectsRequests () {
      return this.$store.state.subjects.subjectsRequests
    },
    isLoadingSubjectsRequests () {
      return this.$store.state.subjects.isLoadingSubjectsRequests
    },
    userRequestedSubjects () {
      if (!this.user) {
        return []
      }
      return this.subjects.filter(subject => this.getIsSubjectRequestedByUser(subject.id))
    },
    userRequestedSubjectsWithProps () {
      return this.userRequestedSubjects
        .map(subject => ({
          ...subject,
          vKlass: this.getKlassesOnSubjects(subject),
          vRequestedBy: this.getSubjectedRequestedBy(subject.id)
        }))
        .sort((a, b) => a.name.localeCompare(b.name)) // Rettet "localCompare" til "localeCompare"
    },
    tasks () {
      return this.$store.state.subjects.tasks
    }
  },
  methods: {
    getKlassesOnSubjects (subject) {
      const cal = this.allCalendarsInHash[subject.calendar_id]
      return cal ? cal.name : ''
    },
    onSelectTab (tab) {
      this.selectedTab = tab
    },
    debounceSearch (event) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.subjectSearchQuery = event.target.value
      }, 400)
    },
    getSubjectedRequestedBy (subjectId) {
      const currentCalendarIds = this.requestedSubjects[subjectId] || []
      return currentCalendarIds.filter(calId => calId !== this.userCalendarId && this.allCalendarsInHash[calId]).map(calId => this.allCalendarsInHash[calId] ? this.allCalendarsInHash[calId]['name'] : [])
    },
    getIsSubjectRequestedByUser (subjectId) {
      const userCalendarId = this.userCalendarId
      const currentUserIds = this.requestedSubjects[subjectId]
      return currentUserIds && currentUserIds.includes(userCalendarId)
    },
    onSetSubjectRequest (subjectId) {
      // Sæt loading til true
      this.$set(this.loadingSubjects, subjectId, true)
      // Tjek om brugeren allerede er på == fjern
      if (this.getIsSubjectRequestedByUser(subjectId)) {
        const idx = this.subjectsRequests.findIndex(subjectsReq => subjectsReq.subject_id === subjectId && subjectsReq.calendar_id === this.userCalendarId)
        if (idx > -1) {
          const reqId = this.subjectsRequests[idx]['id']
          // Fjern den
          docendo.deleteSubjectRequest(this.schoolId, this.schoolYearId, reqId, success => {
            this.$store.commit('removeSubjectRequest', success)
            this.$delete(this.loadingSubjects, subjectId)
          }, failure => {
            this.$delete(this.loadingSubjects, subjectId)
          })
        }
      } else {
        // Tilføj hvis den ikke findes
        docendo.createSubjectRequest(this.schoolId, this.schoolYearId, subjectId, success => {
          this.$store.commit('addSubjectRequest', success)
          this.$delete(this.loadingSubjects, subjectId)
        }, failure => {
          this.$delete(this.loadingSubjects, subjectId)
        })
      }
    },
    getIsSubjectLoading (subjectId) {
      return this.loadingSubjects[subjectId]
    },
    toggleSelectedStatusFilters (filter) {
      const idx = this.selectedStatusFilters.indexOf(filter)
      if (idx < 0) {
        this.selectedStatusFilters.push(filter)
      } else {
        this.selectedStatusFilters.splice(idx, 1)
      }
    },
    toggleKlassTag (filter) {
      const idx = this.selectedKlassFilters.indexOf(filter)
      if (idx < 0) {
        this.selectedKlassFilters.push(filter)
      } else {
        this.selectedKlassFilters.splice(idx, 1)
      }
    },
    setEditSubject (editSubject) {
      console.log('setEditSubject', editSubject)
    },
    getUserNames (subjectId) {
      let calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : []
      if (!calIds || calIds.length < 1 || !calIds[0]) {
        return ''
      }
      return calIds.filter(calId => this.allCalendarsInHash[calId] && this.allCalendarsInHash[calId].type === 'user').map(userCalId => this.allCalendarsInHash[userCalId].name ? this.allCalendarsInHash[userCalId].name : '')
    },
    isShowWithoutTeacher (subjectid) {
      if (!this.isShowSubjectsWithoutTeachers) {
        return true
      } else {
        return !this.subjectHasTeachers(subjectid)
      }
    },
    subjectHasTeachers (subjectId) {
      let calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : []
      let hasTeachers = false
      calIds.forEach(calId => {
        if (this.allCalendarsInHash[calId] && this.allCalendarsInHash[calId].type === 'user') {
          hasTeachers = true
        }
      })
      return hasTeachers
    },
    readSubjectRequests () {
      if (this.schoolYearId) {
        this.$store.dispatch('readSubjects', this.schoolYearId)
        // this.$store.dispatch('readTasks', this.schoolYearId)
        this.$store.dispatch('readSubjectRequests', this.schoolYearId)
      }
    }
  },
  mounted () {
    const urlParams = new window.URLSearchParams(window.location.search)
    this.schoolYearId = urlParams.get('school_year_id') // || 20650
    if (!this.schoolYearId) {
      window.alert('Der mangler et skoleårs ID i URL’en')
    }
    this.readSubjectRequests()
  },
  beforeDestroy () {
    // Clean up any active timeouts
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.request-subjects {
  padding: 1rem;
}

.request-subjects__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.doTable {
  flex: 1;
  border-radius: 4px;
}

ul.doTable__items {
  margin: 0;
}

.doTable__klass {
  margin: 0;
}

.doTable__klass__header {
  display: flex;
  justify-content: space-between;
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  padding: 8px;
  font-weight: bold;
}

.doTable__klass__header label {
  color: #c0c0c0;
}

.subjects {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 10px;
  margin: 0;
  border: 1px solid #e2e8f0;
  border-width: 0 1px 0 1px;
  background-color: #ffffff;
}

.subjects_subject {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 4px 6px;
  color: #ffffff !important;
  border-radius: 4px;
  word-break: break-all;
  background: #2c81ba;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  text-align: left;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  animation: fadeIn;
  cursor: pointer;
}

.subjects_subject.subject--has-room, .subjects_subject.subject--has-user {
  padding-right: 20px;
}

.subjects_subject.subject--has-room.subject--has-user {
  padding-right: 26px;
}

.subjects_subject.subject--has-room:after {
  content: "\ea38";
  position: absolute;
  top: 9px;
  right: 3px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #ffffff;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.subjects_subject.subject--has-user:after {
  content: "\eaf7";
  position: absolute;
  top: 9px;
  right: 3px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #ffffff;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.subjects_subject.subject--has-room.subject--has-user:after {
  content: '';
  width: 18px;
  top: 10px;
  height: 18px;
  background-image: url('https://docendo.dk/static/img/app/bulk_create_subjects_userlocation.png');
  background-size: 100%;
  background-repeat: no-repeat;
}

.subject-dist__header {
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.subject-dist__header__left,
.subject-dist__header__right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.do-bttn.do-bttn--remove {
}

.request-subjects-grid {
  display: flex;
  gap: 1rem;
}

.do-bttn.do-bttn--request-subject {
  padding: 0 6px;
  height: 24px;
}

.do-input {
  background: #fff;
  height: 26px;
  width: 180px;
  border: 1px solid #e4e4e7;
  box-shadow: 0 0 transparent, 0 0 transparent, 0 1px 2px 0 rgba(0, 0, 0, .05);
  transition: width 0.25s, border 0.25s;
}

.do-input:focus {
  border-color: var(--primary);
}

.do-table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.do-table__tasks tbody tr td:first-child {
  font-weight: bold;
}

.td-number {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// RequestSubjects.vue?546aa869